module.exports = __webpack_public_path__ + "static/media/new-score-cell.9af74c53.svg";